import {
  Box,
  Flex,
  Grid,
  GridItem,
  Image,
  ListItem,
  UnorderedList,
  VStack,
} from '@chakra-ui/react';
import { Text } from '@diamond/shared/ui';

import { AdminPaymentProofOcrItem } from '../../types/payment-proof-ocr';
import { formatRecipientBankInfo } from '../../utils/recipient-bank-info';
import { PaymentProofOcrStatusLabel } from './payment-proof-ocr-status-label';

interface PaymentProofOcrCardProps {
  item: AdminPaymentProofOcrItem;
}

const detailFields: {
  label: string;
  getValue: (item: AdminPaymentProofOcrItem) => string;
}[] = [
  {
    label: 'Nominal Transfer',
    getValue: (item) => item.amount,
  },
  {
    label: 'Rekening Penerima',
    getValue: (item) =>
      formatRecipientBankInfo({
        bank_account_number: item.recipientAccountNumber,
        bank_account_holder: item.recipientName,
      }),
  },
  {
    label: 'Tanggal Transfer',
    getValue: (item) => item.transactionDatetime,
  },
  {
    label: 'Nama Pengirim',
    getValue: (item) => item.senderName,
  },
  {
    label: 'Bank Pengirim',
    getValue: (item) => item.senderBank,
  },
  {
    label: 'Tanggal upload bukti transfer',
    getValue: (item) => item.uploadedAt,
  },
];

export function PaymentProofOcrCard({ item }: PaymentProofOcrCardProps) {
  return (
    <Grid
      data-testid="payment-proof-ocr-card"
      templateColumns={{
        base: '1fr',
        md: 'minmax(180px, 240px) minmax(260px, 1fr)',
      }}
      gap={{ base: 4, md: 5 }}
      alignItems="flex-start"
      minW={0}
    >
      <GridItem>
        <Image
          src={item.url}
          alt="Bukti transfer OCR"
          w="100%"
          border="1px solid"
          borderColor="#E2E8F0"
          borderRadius="8px"
          objectFit="contain"
          bg="white"
          loading="lazy"
        />
      </GridItem>
      <GridItem minW={0}>
        <Flex alignItems="flex-start" justifyContent="space-between" gap={4}>
          <Box minW={0}>
            <Text fontSize="16px" fontWeight="700" color="#2F3A3D">
              Hasil Cek Otomatis
            </Text>
            {item.status === 'warning' ? (
              <Box mt={1} color="#FF7A00">
                <Text fontSize="13px" color="#FF7A00" lineHeight="1.35">
                  Potensi bukti transfer tidak sesuai:
                </Text>
                <UnorderedList mt={1} spacing={0.5} pl={3}>
                  {item.warnings.map((warning) => (
                    <ListItem key={warning}>
                      <Text fontSize="13px" color="#FF7A00" lineHeight="1.35">
                        {warning}
                      </Text>
                    </ListItem>
                  ))}
                </UnorderedList>
              </Box>
            ) : null}
          </Box>
          <PaymentProofOcrStatusLabel status={item.status} />
        </Flex>

        <VStack
          alignItems="stretch"
          spacing={3}
          mt={item.status === 'warning' ? 4 : 7}
        >
          {detailFields.map(({ label, getValue }) => (
            <Box key={label}>
              <Text fontSize="12px" color="#8A8F94">
                {label}
              </Text>
              <Text fontSize="18px" color="#333D3F" lineHeight="1.35">
                {getValue(item)}
              </Text>
            </Box>
          ))}
        </VStack>
      </GridItem>
    </Grid>
  );
}
